"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetrieveHostAgenciesAndTravelAgentCountOptions = void 0;
const class_transformer_1 = require("class-transformer");
const SortingPaginationOptions_1 = require("./SortingPaginationOptions");
let RetrieveHostAgenciesAndTravelAgentCountOptions = class RetrieveHostAgenciesAndTravelAgentCountOptions extends SortingPaginationOptions_1.SortingPaginationOptions {
};
exports.RetrieveHostAgenciesAndTravelAgentCountOptions = RetrieveHostAgenciesAndTravelAgentCountOptions;
exports.RetrieveHostAgenciesAndTravelAgentCountOptions = RetrieveHostAgenciesAndTravelAgentCountOptions = __decorate([
    (0, class_transformer_1.Exclude)()
    // eslint-disable-next-line max-len
], RetrieveHostAgenciesAndTravelAgentCountOptions);
//# sourceMappingURL=RetrieveHostAgenciesAndTravelAgentCountOptions.js.map